import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
window.$ = window.jQuery = $;

// Usa require en lugar de import
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.css');
require('owl.carousel');

// Mismo contenido de los 3 slides, ahora en datos (el markup resultante es idéntico)
const slides = [
  {
    bg: '/assets/img/home/slide-index-hot-sale.jpg',
    titulo: 'Piso LVT, ',
    subtitulo: ' similar a la madera',
    logoAlt: 'Decototal - Recubrimientos para muros y pisos',
  },
  {
    bg: '/assets/img/home/slide-index-hot-sale-lambrin.jpg',
    titulo: 'Lambrín Cóncavo',
    subtitulo: 'Para interiores',
    logoAlt: 'Decototal - Recubrimientos para muros y pisos',
  },
  {
    bg: '/assets/img/home/slide-index-contenedor.jpg',
    titulo: 'Contamos con Entrega',
    subtitulo: 'Inmediata',
    logoAlt: 'Amplio stock en bodega',
  },
];

const SliderHome = () => {
  const carouselRef = useRef(null);

  useEffect(() => {
    // Se scopea a este carrusel con ref (antes era el selector global '.owl-carousel')
    const $carousel = $(carouselRef.current);
    $carousel.owlCarousel({
      items: 1,
      loop: true,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 4000,
      smartSpeed: 800,
    });

    // Limpia el carrusel al desmontar el componente
    return () => {
      $carousel.trigger('destroy.owl.carousel');
    };
  }, []);

  const irSiguienteSeccion = (e) => {
    e.preventDefault();
    const destino = document.getElementById('nosotros');
    if (!destino) return;
    const reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    destino.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
  };

  return (
    <section className="full-screen top-position1 p-0 position-relative dt-hero">
      <div ref={carouselRef} className="slider-fade2 owl-carousel owl-theme w-100 min-vh-100">
        {slides.map((s) => (
          <div
            key={s.bg}
            className="item bg-img cover-background dark-overlay"
            data-overlay-dark="75"
            style={{ backgroundImage: `url('${s.bg}')` }}
          >
            <div className="container d-flex flex-column">
              <div className="row align-items-center min-vh-100 pt-6 pt-md-0">
                <div className="col-md-11 col-lg-9 col-xl-8 col-xxl-7 mb-1-9 mb-lg-0 pt-6 pb-12 py-sm-6">
                  <div className="banner-title1">
                    <div className="d-flex align-items-center">
                      <h1 className="mb-0 font-weight-700 lh-1 text-shadow">{s.titulo}</h1>
                      <div className="ms-3 d-none d-sm-inline-block">
                        <img
                          src="/assets/img/home/slide-logo-small-home.jpg"
                          alt={s.logoAlt}
                          className="rounded-pill"
                        />
                      </div>
                    </div>
                    <div className="fst-italic font-weight-800 h1 mb-0 lh-1 text-shadow">{s.subtitulo}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botón centrado abajo: lleva a la siguiente sección (#nosotros en UnoHome) */}
      <a
        href="#nosotros"
        className="dt-hero__scroll"
        onClick={irSiguienteSeccion}
        aria-label="Ir a la siguiente sección"
      >
        <i className="fas fa-chevron-down" aria-hidden="true"></i>
      </a>
    </section>
  );
};

export default SliderHome;